import { render, staticRenderFns } from "./SetNewPassword.vue?vue&type=template&id=1a428f33"
import script from "./SetNewPassword.vue?vue&type=script&lang=ts"
export * from "./SetNewPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports